export const RECS_REQUEST_KEY = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';

export const HYDRATION_STANDARD_SCROLL_BUFFER = 750;
